function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aaaaaaa{fill:#fff;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "aaaaaaa",
  d: "M49.25,2H13.05A9.05,9.05,0,0,0,4,11.05v72.4a9.05,9.05,0,0,0,9.05,9.05h54.3a9.05,9.05,0,0,0,9.05-9.05V29.15Z",
  transform: "translate(-4 -2)"
}), /*#__PURE__*/React.createElement("path", {
  className: "aaaaaaa",
  d: "M14,2V29.15H41.15",
  transform: "translate(31.25 -2)"
}), /*#__PURE__*/React.createElement("line", {
  className: "aaaaaaa",
  y1: 27.393,
  transform: "translate(36.2 45.25)"
}), /*#__PURE__*/React.createElement("line", {
  className: "aaaaaaa",
  x2: 26.652,
  transform: "translate(22.874 58.576)"
}));

var SvgFilePlus = function SvgFilePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 78.4 96.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-plus.4d068df0.svg";
export { ForwardRef as ReactComponent };